import Swiper from 'swiper/bundle';
var swiperImage = new Swiper(".banner-swipper", {
     loop: true,
     spaceBetween: 30,
     slidesPerView: 1,
     speed:1000,
     effect: 'fade',
     fadeEffect: {
       crossFade: true
     },
     autoplay: {
          delay: 5000,
          autoplayDisableOnInteraction: false,
          pauseOnMouseEnter: false,
     },
     pagination: {
          el: '.swiper-pagination',
          clickable: 'true',
          // type: 'bullets',
          renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
     
     },
     on: {
          slideChange: function () {
              var realIndex = swiperImage.realIndex; 
              var bannerContentItems = document.querySelectorAll('.banner-content-swiper-item');
              bannerContentItems.forEach(function(item, index) {
                  var dataValue = parseInt(item.getAttribute('data-value'));
                  if (dataValue === realIndex || dataValue === realIndex - 4) { 
                      item.classList.add('active');
                  } else {
                      item.classList.remove('active');
                  }
              });
          },
      },
});

var mySwiper = new Swiper('.banner-content-swiper', {
  // Optional parameters
     loop: true,
     autoplayDisableOnInteraction: false,
     slidesPerView: 6,  
     spaceBetween:32,
     autoHeight: true,
     autoplay: {
          delay: 5000,
     }, 
})

